import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { EnhancedStore } from '@reduxjs/toolkit';

import { Exception } from '@labradorsports/utils';

import { Selectors } from '../store/index.js';

export class Logger {
    env: EnvSpec;

    store: EnhancedStore;

    constructor(env: EnvSpec) {
        this.env = env;
    }

    setStore(store: EnhancedStore) {
        this.store = store;
    }

    _log = (level: 'info' | 'warn' | 'error', message: string, data?: Record<string, any>) => {
        if (!PROD) console.log(message, APP ? JSON.stringify(data) : data);

        const state = this.store.getState();

        if (!E2E && !SSR) {
            datadogLogs.logger.log(
                message,
                {
                    data,
                    route: APP ? window.location.hash : window.location.pathname,
                    uid: state?.auth.user?.uid,
                    timestamp: new Date().toISOString().slice(11),
                },
                level
            );
        }
    };

    log = (message: string, data: Record<string, any> = null) => {
        this._log('info', message, data);
    };

    warn = (message: string, data: Record<string, any> = null) => {
        if (!E2E && !SSR) {
            datadogRum.addAction('warning', data);
        }

        this._log('warn', message, data);
    };

    exception = (exc: Exception) => {
        if (exc.level === 'error') {
            this.error(exc);
        } else {
            this.warn(exc.fullMessage(), exc.toJSON(this.env.baseUrl));
        }
    };

    error = (error: Exception) => {
        if (!PROD) console.error(error.nestedError ?? error.details);
        if (APP) console.log(error.message ?? error);

        if (!E2E && !SSR) {
            datadogRum.addError(
                error?.nestedError instanceof Error ? error?.nestedError : error,
                error.toJSON(this.env.baseUrl)
            );
        }

        this._log('error', error.message, error.toJSON(this.env.baseUrl));
        this.log('state', Selectors.loggableState(this.store.getState()));
        this.log('actionLog', { actionLog: this.store.getState().main.actionLog });
    };
}

export default Logger;
